import _ from "underscore";

import Model from "backdraft-app/src/model";

function insertIdToBaseUrlAtIndex(base, id, index) {
  return [base.slice(0, index), base[index - 1] === "/" ? "" : "/", encodeURIComponent(id), base.slice(index)].join('');
}

class BaseModel extends Model {
  url() {
    var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url');
    if (!base) {
      throw new Error('A "url" property or function must be specified');
    }
    if (this.isNew()) {
      return base;
    }
    var dotIndex = base.lastIndexOf(".");
    var questionIndex = base.lastIndexOf("?");

    if (dotIndex > -1) {
      return insertIdToBaseUrlAtIndex(base, this.id, dotIndex);
    } else if (questionIndex > -1) {
      return insertIdToBaseUrlAtIndex(base, this.id, questionIndex);
    } else {
      return base.replace(/([^/])$/, '$1/') + encodeURIComponent(this.id);
    }
  }
}

export default BaseModel;
